// Guide pages, in reading order. ArticleLayout lists the others under
// "Guías relacionadas" on each guide. Each path must also be in PAGES
// (src/seo.js), the routes in App.js, public/sitemap.xml and public/llms.txt.
export const GUIDES = [
  { path: '/que-es-manifestacion-de-valor-electronica', title: '¿Qué es la Manifestación de Valor Electrónica (MVE)?' },
  { path: '/como-prepararse-para-la-mve', title: '¿Cómo me preparo para la MVE y qué sistema puedo usar?' },
  { path: '/como-digitalizar-edocument-manifestacion-de-valor', title: '¿Cómo digitalizo un e-document para la MVE?' },
  { path: '/como-convertir-pdf-vucem', title: 'Cómo convertir un PDF al formato VUCEM' },
];
